export default "__VITE_ASSET__ea8acb97__"